import { ICompany } from 'app/shared/model/company.model';

export interface IAllowedCompanies {
  id?: number;
  company?: ICompany | null;
}

export const defaultValue: Readonly<IAllowedCompanies> = {};
